import _ from "lodash";

import * as updateCookie from '@/api/crm/cookies/updateCookie';
import * as deleteCookie from '@/api/crm/cookies/deleteCookie';
import * as getCookies from '@/api/crm/cookies/getCookies.js';


export default {
    namespaced: true,
    state: {
        methods: ["Cookie", "SessionStorage", "LocalStorage"],
        types: ["Session", "Persistent"],
        categories: ["Nessecary",
            "Preferences",
            "Analytics",
            "Marketing",
            "Unclassified"],
        cookies: [],
    },
    mutations: {
        gotCookies(state, result) {
            state.cookies = result;
        },
    },
    actions: {

        async getAll({ commit, getters }, force = true) {
            if (!force && getters.cookies.length > 0) return;
            const result = await getCookies.get();
            console.log("Cookies", result);
            if (result) commit("gotCookies", result);
        },
        async update({ dispatch }, dto) {
            await updateCookie.put(dto);
            await dispatch("getAll")
        },
        async delete({ dispatch }, id) {
            await deleteCookie.del(id);
            await dispatch("getAll")
        },


    },
    getters: {
        cookie: state => (id) => state.cookies.find(e => e.id === id),
        cookies: state => state.cookies,
        methods: state => state.methods,
        types: state => state.types,
        categories: state => state.categories,
    }
};
